// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__2gCsw","Question":"ActiveQuiz_Question__2vmtx"};